import { render, staticRenderFns } from "./_register.vue?vue&type=template&id=bf041374&scoped=true&lang=pug&"
import script from "./_register.vue?vue&type=script&lang=js&"
export * from "./_register.vue?vue&type=script&lang=js&"
import style0 from "./_register.vue?vue&type=style&index=0&id=bf041374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf041374",
  null
  
)

export default component.exports